import { render } from "./BioIntelligentPart1.vue?vue&type=template&id=be556eec"
import script from "./BioIntelligentPart1.vue?vue&type=script&lang=js"
export * from "./BioIntelligentPart1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__